'use client'

import React, { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { configuredMillsPublicOrigin, MILLS_QUERY_KEY } from '../../lib/mills/public-client'
import { loadMillsCompetitionCards } from '../../lib/mills/competition-cards'
import { MillsModuleBoundary } from './MillsModuleBoundary'

function CompetitionList({ origin }: { origin: string }) {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  const competitions = useQuery({
    queryKey: [...MILLS_QUERY_KEY, 'competitions', origin],
    queryFn: ({ signal }) => loadMillsCompetitionCards(signal),
    enabled: mounted,
    retry: false,
  })
  if (competitions.isError)
    return <p role="status">Mills competitions are temporarily unavailable.</p>
  if (competitions.isPending) return <p role="status">Loading Mills competitions…</p>
  if (!competitions.data.length)
    return <p role="status">No published Mills competitions are available yet.</p>
  return (
    <ul className="divide-y divide-white/10">
      {competitions.data.map((competition) => (
        <li key={competition.id} className="py-5">
          <a
            className="font-bold text-white underline decoration-[var(--alli-red)] underline-offset-4 hover:text-white/70"
            href={`https://mills-web-production.fourth-sale.workers.dev/competitions/${encodeURIComponent(competition.slug)}`}
            rel="noreferrer"
          >
            {competition.name}
          </a>
        </li>
      ))}
    </ul>
  )
}

export function MillsPublicCompetitions() {
  if (process.env.NEXT_PUBLIC_MILLS_ENABLED !== 'true') {
    return <p role="status">Mills competitions are not enabled.</p>
  }
  const origin = configuredMillsPublicOrigin()
  if (!origin) return <p role="status">Mills competitions are not configured.</p>
  return (
    <MillsModuleBoundary>
      <CompetitionList origin={origin} />
    </MillsModuleBoundary>
  )
}
